<template>
    <div class="about">
        <TestimonialPhoto :slides="testimonials" />
        <div class="container service-container">
            <SectionTitle title="Brands Serviced" class="top-margin"/>
        </div>
        <Sponsors/>
        <div class="container service-container no-margin-bottom">
            <SectionTitle title="Core Services" />
            <Services />
        </div>
        <div class="container section-container">
            <SectionTitle title="Our Story"/>
        </div>
        <ContentBlock
            :title="content1.title"
            :content="content1.content"
            :button="false"
            :border="false"
            :reverseMobile="true"
            :img="content1.img"
        />
    </div>
</template>

<script>
import Sponsors from '../components/Sponsors';
import ContentBlock from '../components/ContentBlock';
import TestimonialPhoto from '../components/TestimonialPhoto';
import SectionTitle from '../components/SectionTitle';
import Services from '../components/Services'

export default {
    name: "About",
    components: {
        Sponsors,
        ContentBlock,
        TestimonialPhoto,
        SectionTitle,
        Services,
    },
    metaInfo: {
        title: 'About | Uptown Creative',
        meta: [{
            name: 'description', 
            content: "About | Uptown Creative"
        }]
    },
    data(){
        return{
            slides : [],
            testimonials: [
                {
                    author: 'Zachary Harrison',
                    content: '"Austin upscaled his team and resources to seamlessly meet our increasing needs, consistently delivering high quality products. He handled more than 600 projects for us... He has my highest recommendation."',
                    photo: '/images/testimonials/uptowncreative-zach-harrison.jpg',
                    title: 'Managing Director, Compass'
                },
                {
                    author: 'Chad Rogers',
                    content: '"Austin has handled my real estate website for 9 years. I highly recommend him and his company.',
                    photo: '/images/testimonials/uptowncreative-chad-rogers.jpeg',
                    title: 'Hilton & Hyland'
                },
                {
                    author: 'Rachel Markovitz',
                    content: '"Austin is reliable and dedicated to his profession. He works efficiently with an outstanding level of service, professionalism and follow-through. Austin has my highest recommendation."',
                    photo: '/images/testimonials/uptowncreative-rachel-markovitz.jpg',
                    title: "HK Lane | Christie's International"
                },
                {
                    author: 'Nancy Cerda-Zein',
                    content: '"Cerda-Zein Real Estate has had the pleasure of working along side Austin for 10 years. He is very responsive and makes us feel like we are his only client."',
                    photo: '/images/testimonials/uptowncreative-nancy-cerda-zein.jpg',
                    title: 'Founder, Cerda-Zein Real Estate'
                },
                {
                    author: 'Tara Ozanyan',
                    content: '"Austin is the absolute best!! I have worked with him for many years and he has always been incredibly professional and prompt, which I have always appreciated. I would highly recommend Austin."',
                    photo: '/images/testimonials/uptowncreative-tara-ozanyan.jpg',
                    title: 'Compass'
                },

            ],
            content:{
                title: "Serving the world's best hospitality properties and top real estate agents.",
                details: "Our clients range from startups to Fortune 500 companies."

            },
            content1:{
                title: 'LA to NY',
                content: 'Established in 2009, Uptown Creative is an agile team of designers and web developers specializing in the luxury real estate industry. Our team is dedicated to helping brands grow and make great first impressions. Headquartered West of Toronto, our nationwide client base extends from Los Angeles to New York.',
                img: '/images/uptowncreative-about.jpg'
            },
        }
    },
}   
</script>

<style lang="scss" scoped>
.home-title{
    padding: 2rem 0;
}
.first-block{
    margin-top: 1rem;
}
.service-container{
    margin-top: 4rem;
}

@media (max-width: $mobile) { 
    .home-title{
        padding: 2rem 0;
        padding-bottom: 0;
    }
    .service-container{
        margin: 33px 2rem 0;
    }
    .section-container{
        margin-top: 64px;
    }
}

</style>